import {SVGProps} from 'react';



function BubbleBottomIcon(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="1.92em"
            height="1em"
            viewBox="0 0 1106 576"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M99.19 544.26c25.74 97.59 122 121.55 205.16 225.7C387.5 874.13 381.8 971.49 514.04 983.7 646.27 995.9 870.06 868.1 930.99 695c90.52-172.62-20.42-349.94-96.96-391.75-76.53-41.81-127.02 34.52-264.83 50.87-137.81 16.35-237.79-65.43-326.55-18.33C129.43 395.84 73.44 446.66 99.19 544.26z"
                fill="#E1EBFD"
                fillOpacity={0.34}
            />
            <path
                opacity={0.05}
                d="M233.78 544.37c17.78 70.69 64.47 83.87 123.84 158.8 59.38 74.91 70.87 149.41 166.7 157.06 95.83 7.64 216.09-54.38 269.93-155.36 53.84-100.99 53.38-211.4-4.03-296.22-57.41-84.81-125.46-56.21-225.61-43.06-100.15 13.16-174.32-.93-236.43 24.68-62.1 25.6-112.17 83.42-94.4 154.1z"
                fill="#46A3FD"
            />
        </svg>
    );
}

export default BubbleBottomIcon;
